{
  "name": "profit-hunger-app",
  "version": "1.2.0",
  "scripts": {
    "install": "cp ./package.json ./public",
    "ng": "ng",
    "start": "ng serve --ssl --host localhost.sparbanken.me",
    "build": "./scripts/version.sh && ng build --output-hashing all",
    "test": "ng test --coverage --watch=false",
    "lint": "ng lint",
    "style-lint": "stylelint src/**/*.scss --fix"
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "^22.0.1",
    "@angular/common": "^22.0.1",
    "@angular/compiler": "^22.0.1",
    "@angular/core": "^22.0.1",
    "@angular/forms": "^22.0.1",
    "@angular/material": "^22.0.1",
    "@angular/platform-browser": "^22.0.1",
    "@angular/router": "^22.0.1",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^22.0.0",
    "@angular/build": "^22.0.1",
    "@angular/cli": "^22.0.1",
    "@angular/compiler-cli": "^22.0.1",
    "@eslint/js": "^10.0.1",
    "@sparbanken-syd/auth-backend": "^2.6.4",
    "@sparbanken-syd/personnummer": "^3.0.1",
    "@sparbanken-syd/sparbanken-syd-bankid": "^22.0.0",
    "@sparbanken-syd/sparbanken-syd-qr": "^22.0.0",
    "@sparbanken-syd/sparbanken-syd-theme": "^22.0.1",
    "@sparbanken-syd/sparbanken-syd-theme-m3": "^22.0.0",
    "@sparbanken-syd/teradata-user": "3.4.1",
    "@stylistic/eslint-plugin": "^5.7.1",
    "@vitest/coverage-v8": "^4.1.2",
    "angular-eslint": "^22.0.0",
    "eslint": "^10.2.0",
    "jsdom": "^27.1.0",
    "postcss": "^8.5.6",
    "stylelint": "^17.1.0",
    "stylelint-config-sass-guidelines": "^13.0.0",
    "stylelint-config-standard-scss": "^17.0.0",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.54.0",
    "vitest": "^4.1.2"
  },
  "packageManager": "yarn@4.17.0"
}
